// extracted by mini-css-extract-plugin
module.exports = {"change-page":"pagination-buttons_change-page__HSMQW","disabled":"pagination-buttons_disabled__TikmP"};